import { createSelector } from 'reselect'

export const getErrorMessage = createSelector(
  state => state && state.scheduleTechnicalInspection && state.scheduleTechnicalInspection.error ? state.scheduleTechnicalInspection.error : '',
  errorMessage => errorMessage
)
